import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import { isApiResponse, isReportAccess, date_range_config,user_activities } from '../../helpers/utils.js';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
// import MerchantFilter from '../../filters/MerchantFilter.jsx';
// import ChainFilter from '../../filters/ChainFilter.jsx';
// import StoreFilter from '../../filters/StoreFilter.jsx';
// import UtidFilter from '../../filters/UtidFilter.jsx';
import AcquirerFilter from '../../filters/AcquirerFilter.jsx';
import TenderModeFilter from '../../filters/TenderModeFilter2.jsx';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('1', '1', '2020-02-01','1');

class AcquirerSummaryReportOverallSales extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantID:'',
            chainID:'',
            storeID:'',
            acqBankIds:'',
            is_aggr:1,
            ciutidIds: '',
            tenderModeIDs:'',

        }

    }

    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, 'acquirer_summary_report_overall_sales');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }
    componentDidUpdate() {

    }

    componentDidMount() {
       this.get_filtered_acq_summary_report(this.state.object_type,this.state.object_code,'');
       user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'acquirer_summary_report_overall_sales','sparcs')
    }

    get_filtered_acq_summary_report(object_type, object_code, event) {
        var that = this;
        isApiResponse(false);
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }

        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            bids: this.state.acqBankIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
            is_aggr: this.state.is_aggr,
            tender_mode: this.state.tenderModeIDs
        };
        if ($.fn.DataTable.isDataTable('#AcqSummaryOverallSalesTable')) {
            $('#AcqSummaryOverallSalesTable').DataTable().clear().destroy();
        }
        var AcqSummaryTable = $('#AcqSummaryOverallSalesTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": false,
                "bDestroy": true,
                "paging": false,
                "searching": false,
                "bInfo" : false,
                "autoWidth": false,
                "responsive": false,
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/acq-summary-report-tender-wise",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        var rows = json.data || [];
                        var nonTotal = [];
                        var totals = [];
                        rows.forEach(function(r){
                            var acq = ((r.acq_bank_name || r.acquirer || r.acquirer_name || r.bank_name || r.acq_name) || '').toString().toUpperCase();
                            if (acq === 'TOTAL') {
                                totals.push(r);
                            } else {
                                nonTotal.push(r);
                            }
                        });
                        return nonTotal.concat(totals);
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: [
                    {"data": function(row){
                        return row.acq_bank_name || row.acquirer || row.acquirer_name || row.bank_name || row.acq_name || '';
                    }},
                    {"data": function(row){
                        return row.tender_mode || row.tender_mode_name || row.tender || row.tender_name || '';
                    }},
                    {"data": function(row){
                        var v = row.sales_count != null ? row.sales_count
                            : (row.total_txncount != null ? row.total_txncount
                            : (row.txn_count != null ? row.txn_count : row.count));
                        return v != null ? v : '';
                    }},
                    {"data": function(row){
                        var v = row.sales_amount != null ? row.sales_amount
                            : (row.total_txnamount != null ? row.total_txnamount
                            : (row.txn_amount != null ? row.txn_amount : row.amount));
                        return v != null ? v : '';
                    }},
                ],
                "columnDefs": [
                    {
                        render: function (data) {
                            if (data === null || data === undefined || data === '') return data;
                            var num = parseFloat(data);
                            if (isNaN(num)) return data;
                            return num.toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                        },
                        "targets": [ 2, 3],
                        "className": "text-right"
                    },
                ],
                "createdRow": function(row, data){
                    var acq = (data && (data.acq_bank_name || data.acquirer || data.acquirer_name || data.bank_name || data.acq_name) || '').toString().toUpperCase();
                    if (acq === 'TOTAL') {
                        $(row).css('font-weight', 'bold');
                    }
                }
            });
    }


    acqSummaryDownloadCheck(){
    var filters = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            acq_bank_codes: this.state.acqBankIds,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            download: 1,
            utids: this.state.ciutidIds,
            tender_modes: this.state.tenderModeIDs,
        };

    if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.ciutidIds==='' && this.state.acqBankIds===''){

        confirmAlert({
            //title: 'Warning',
            message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
            buttons: [{
                label: 'OK',
                onClick: () => {
                    this.refs.downloadAllReport.downLoadReport(filters, '/summary_reports/acquirer/summary_tender_wise','acquirer_summary_report_overall_sales','31');
                }
            },
                {
                    label: 'Cancel',
                }
            ]
        });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, '/summary_reports/acquirer/summary_tender_wise','acquirer_summary_report_overall_sales','31');
        }
    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        // if(this.state.object_type==='Innoviti')
        // {
        //     this.refs.merchantFilter.restMerchantFilter();
        //     this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
        //     this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
        //     this.refs.reloadUtid.ci_utid('','','',false,'');
        // }
        // if(this.state.object_type==='Merchant')
        // {
        //     this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
        //     this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
        //     this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        // }
        // if(this.state.object_type==='Chain')
        // {
        //     this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
        //     this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        // }
        // if(this.state.object_type==='Store')
        // {
        //     this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        // }
        this.refs.acquirerFilter.resetAcquirerFilter();
        this.refs.tenderModeFilter.restTenderModeFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            acqBankIds:'',
            ciutidIds: '',
            tenderModeIDs:'',
            isChange: false,
        })
        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }
    handleAcquirer = (optionSelected, acqBankIds) =>
    {
        this.setState({
            acqBankIds:acqBankIds,
            isChange: true
        });
    }
    handleTenderMode = (optionSelected, tenderModeIDs) =>
    {
        this.setState({
            tenderModeIDs:tenderModeIDs,
            isChange: true
        });
    }
    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Acquirer Summary Report (Overall Sales)</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                            </div>
                                            {/* {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null} */}
                                            {/* {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null } */}
                                            {/* {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null } */}
                                            {/* <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div> */}
                                            {/*{this.state.acq_bank_list_box===true?*/}
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Acquirer:</label>
                                                <AcquirerFilter ref="acquirerFilter" onSelectAcquirer = {this.handleAcquirer}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Tender Mode </label>
                                                <TenderModeFilter ref="tenderModeFilter" onSelectTenderMode = {this.handleTenderMode} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-6 filter-bottom5 padd-5" style={{paddingTop: '22px'}}>
                                                {this.state.isChange===true?
                                                    <span className="apply-notification">Please click on Apply button</span>:null
                                                }
                                                <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_acq_summary_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                                <button type="button" className="primary reset-filter" role="button" onClick={this.reset_all.bind(this)}>Reset</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="row" style={{marginBottom: '15px'}}>
                                        <div className="col-md-12 text-right">
                                            <a href="#" className="exportButton" role="button" onClick={this.acqSummaryDownloadCheck.bind(this)} style={{position: 'static', display: 'inline-block', float: 'none'}}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="AcqSummaryOverallSalesTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Acquirer</th>
                                                    <th>Tender Mode</th>
                                                    <th className="text-right">Sales Count</th>
                                                    <th className="text-right">Sales Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <DownloadAllReport ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

       );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( AcquirerSummaryReportOverallSales);
